import { render } from "./CompareRoundCard.vue?vue&type=template&id=cf948226&scoped=true"
import script from "./CompareRoundCard.vue?vue&type=script&lang=js"
export * from "./CompareRoundCard.vue?vue&type=script&lang=js"

import "./CompareRoundCard.vue?vue&type=style&index=0&id=cf948226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf948226"]])

export default __exports__